import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

export interface ServiceManagementData {
  id: string;
  name: string;
  description: string;
  icon?: string;
  clientsCount: number;
  devicesCount: number;
}

/** Accesos del pie de la tarjeta, en el orden en que se muestran. */
export type ServiceManagementAction = 'clients' | 'devices' | 'models';

@Component({
  selector: 'app-service-management-card',
  templateUrl: './service-management-card.component.html',
  styleUrl: './service-management-card.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceManagementCardComponent {
  @Input() service!: ServiceManagementData;
  @Input() loading = false;

  /**
   * Disponibilidad de cada acceso. Se recibe del contenedor porque depende del menú del usuario
   * (RBAC) y de si el producto publica esa vista: no todos tienen `models`.
   */
  @Input() canManageClients = true;
  @Input() canManageDevices = true;
  @Input() canManageModels = true;

  @Output() manageClients = new EventEmitter<string>();
  @Output() manageDevices = new EventEmitter<string>();
  @Output() manageModels = new EventEmitter<string>();

  onManageClients() {
    this.manageClients.emit(this.service.id);
  }

  onManageDevices() {
    this.manageDevices.emit(this.service.id);
  }

  onManageModels() {
    this.manageModels.emit(this.service.id);
  }

  /** Tooltip del acceso: explica por qué está deshabilitado en vez de dejar un botón mudo. */
  actionTooltip(action: ServiceManagementAction): string {
    switch (action) {
      case 'clients':
        return this.canManageClients ? `Clientes de ${this.service.name}` : 'No tienes acceso a la gestión de clientes';
      case 'devices':
        return this.canManageDevices ? `Dispositivos de ${this.service.name}` : `${this.service.name} no tiene vista de dispositivos disponible`;
      case 'models':
        return this.canManageModels ? `Modelos de ${this.service.name}` : `${this.service.name} no tiene vista de modelos disponible`;
    }
  }
}
